import _ from 'lodash';
import { axiosInstance } from '../helpers/axios';

export const educationTaxonomyService = { findAllPublic };

function findAllPublic(query = {}) {
  return axiosInstance
    .get('/public/education-taxonomy', { params: query })
    .then(handleResponse)
    .catch(error => {
      if (error && error.response) return handleResponse(error.response);
      throw error;
    });
}

function handleResponse(response) {
  const data = response.data;
  if (!_.includes([200, 201, 204], response.status)) {
    const error = (data && data.message) || response.statusText;
    // eslint-disable-next-line no-throw-literal
    throw { status: response.status, error };
  }
  return data;
}
